import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { AuthApiError } from './AuthContext';
import { useAuth } from './AuthContext';
import { AuthPageShell, fieldClass, primaryButtonClass } from './AuthPageShell';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      await login(email, password);
    } catch (cause) {
      setError(
        cause instanceof AuthApiError && cause.code === 'invalid_credentials'
          ? 'Feil e-postadresse eller passord.'
          : 'Innloggingen kunne ikke fullføres. Prøv igjen.',
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <AuthPageShell title="Logg inn" lead="dnam-ecrf — DNAm-kalibreringsstudien. Kun for inviterte studiemedarbeidere.">
      <form onSubmit={submit} className="space-y-5">
        <label className="block text-sm font-medium">
          E-post
          <input
            className={fieldClass}
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <label className="block text-sm font-medium">
          Passord
          <input
            className={fieldClass}
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {error && (
          <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
            {error}
          </p>
        )}
        <button className={primaryButtonClass} disabled={pending} type="submit">
          {pending ? 'Logger inn…' : 'Logg inn'}
        </button>
      </form>
      <Link to="/glemt-passord" className="mt-4 block text-center text-xs text-black/45 hover:text-black/70">
        Glemt passord?
      </Link>
      <p className="mt-3 text-center text-xs text-black/45">
        Det finnes ingen offentlig registrering. Nye brukere opprettes av administrator via invitasjon.
      </p>
    </AuthPageShell>
  );
}
